export enum RoleEnum {
    ProductMaster = "ProductMaster",
    ClientSuperAdmin = "ClientSuperAdmin",
    ClientAdmin = "ClientAdmin",
    CustomerUser = "CustomerUser",
}
